<!-- 
  消息列表 
 -->
<template>
  <div class="messageList">
  	<div class="message" v-clickoutside="hide">
      <div class="title">
        <div class="tabs">
          <span class="tab" :class="{'active': currentView === 0}" @click="tabClick(0)">全部消息</span>
          <span class="tab" :class="{'active': currentView === 1}" @click="tabClick(1)">未推送提醒</span>
          <span class="tab" :class="{'active': currentView === 3}" @click="tabClick(3)">下载</span>
        </div>
        <el-button class="readBtn" type="text" :class="{'mRead': mUnreadCount === 0}" @click="markedAsRead">一键消息已读</el-button>
      </div>
      <div class="filter" 
        onselectstart="return false" 
        v-if="currentView !== 3"
      >
        <div class="filter-tag-title">筛选标签：</div>
        <div class="filter-title">
          <span class="tag"
            v-for="(tag, index) in tags"
            :key="index"
            :class="[tag.isChoose ? tag.class : '']"
            @click="chooseFilter(index)"
            v-if="index <= 3">
            {{tag.label}}
          </span>
          <span @click="openFilter" class="open-filter-icon">
            <i v-if="showFilter" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </span>
        </div>
        <div class="filter-content" v-if="showFilter">
          <span class="tag"
            v-for="(tag, index) in tags"
            :key="index"
            :class="[tag.isChoose ? tag.class : '']"
            @click="chooseFilter(index)"
            v-if="index > 3">
            {{tag.label}}
          </span>
        </div>
        <div class="filter-tag-title">时间筛选标签：</div>
        <div class="filter-title">
          <span class="tag"
            v-for="(tag, index) in timeTags"
            :key="index"
            :class="[tag.isChoose ? tag.class : '']"
            @click="chooseTimeFilter(index)"
            >
            {{tag.label}}
          </span>
        </div>
      </div>
      <div class="content" ref="comLeft" :class="{'emptyStyle': mPushlinklist.length === 0}" v-loading="loading">
        <div class="empty" v-if="mPushlinklist.length === 0">
          <img src="../../assets/imgs/empty.png" height="109" width="202" alt="">
          <h3 class="text">暂无推送消息</h3>
        </div>
        <div class="messages" v-else>
          <div class="item" v-for="(pushlink,index) in mPushlinklist" :key="index">
            <i class="iconPre" :class="colorIcon(pushlink)"></i>
            <div class="middle">
              <div class="frist">
                <el-tooltip
                  effect="light"
                  :content="formatContent(pushlink.msg, 'title')"
                  placement="top-start">
                  <span class="name" :class="{'noRead': pushlink.isRead === 0}" @click="showDetail(pushlink)">{{formatContent(pushlink.msg, 'title')}}</span>
                </el-tooltip>
                <span class="time">{{formatTime(pushlink.pushTime)}}</span>
              </div>
              <div class="bottom">
                <p class="text" :class="{'unfold': !pushlink.isUnfold}">
                  <template
                  v-if="formatContent(pushlink.msg, 'downLoadUrl')"
                  >
                    <span class="download-content">{{formatContent(pushlink.msg, 'content')}}</span>
                    <a
                      :href="getPreviewUrl(pushlink.msg)"
                      target="_black"
                      class="link">
                      预览
                    </a>
                    <a
                      :href="getDownloadUrl(pushlink.msg)"
                      :download="formatContent(pushlink.msg, 'content')"
                      class="link">
                      下载
                    </a>
                  </template>
                  <template v-else>{{formatContent(pushlink.msg, 'content')}}</template>
                  <el-button type="text" v-if="JSON.parse(pushlink.refArray).length > 1" @click="showDetail(pushlink)">查看详情</el-button>
                </p>
                <div class="unfoldBtn" v-if="false">... <el-button type="text" @click="unfoldText(pushlink)">展开</el-button></div>
              </div>
            </div>
          </div>
        </div>
        <div class="load-more" v-if="mPushlinklist.length">
          <template v-if="showMore">
            <i class="el-icon-loading"></i>
            加载更多
          </template>
          <template v-else>没有更多</template>
        </div>
      </div>
    </div>
    <transition name="slide">
      <detail
        ref="detail"
        v-if="detailShow"
        :id="detailId"
        :moduleName="popModel"
        @close="closeDetail"
      >
      </detail>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="detailShow" @click="detailShow=false"></div>
    </transition>
  </div>
</template>

<script>
import * as api from 'src/api'
import * as utils from 'src/utils'
import { LS } from 'assets/js/storage'
import detail from 'components/list/detail'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import { mapActions } from 'vuex'
import { Message } from 'element-ui'
import * as message from 'src/config/message-config'
export default {
  created () {
    this.tabClick(0)
  },
  components: {
    detail
  },
  data () {
    return {
      currentView: 0,
      isUnfold: true,
      loading: true,
      pushlinkParams: {
        page: 1,
        pageSize: 15,
        isRemind: 0
      },
      filterArray: [],
      filterTime: 0,
      mPushlinklist: [],
      mUnreadCount: 0,
      total: 0,
      detailShow: false,
      detailId: 0,
      popModel: '',
      curMessage: [],
      deleteBox: false,
      showFilter: false, // 展示筛选按钮
      tags: message.tags,
      timeTags: message.timeTags,
      showMore: true
    }
  },
  methods: {
    ...mapActions([
      'updateRemindCount'
    ]),
    openFilter () {
      this.showFilter = !this.showFilter
    },
    chooseFilter (index) { // 选中筛选按钮样式改变
      if (index === 0) {
        this.tags.forEach((item) => {
          item.isChoose = false
        })
        this.tags[0].isChoose = true
      } else {
        this.tags[0].isChoose = false
        this.tags[index].isChoose = !this.tags[index].isChoose
      }
      this.filterArray = []
      this.tags.forEach((item) => {
        if (item.isChoose && item.value) {
          this.filterArray.push(item.value)
        }
      })
      if (this.filterArray.length === 0) {
        this.tags[0].isChoose = true
      }
      this.chooseTimeFilter(this.filterTime)
    },
    chooseTimeFilter (index) {
      this.timeTags.forEach((item) => {
        item.isChoose = false
      })
      this.timeTags[index].isChoose = true
      this.filterTime = index
      this.setFilterParmas()
    },
    setFilterParmas () {
      this.pushlinkParams.page = 1
      if (this.filterArray.length) { // 非全部按钮
        this.pushlinkParams.refEntityIn = JSON.stringify(this.filterArray)
      } else { // 全部按钮
        delete this.pushlinkParams.refEntityIn // 删除refEntityIn这个参数，
      }
      if (this.pushlinkParams.isRemind) {
        this.notPushTimeRange(this.filterTime)
      } else {
        this.serchTimeRange(this.filterTime)
      }
      this.loadPushlinkList()
    },
    // 获取本月有多少天
    getMonthDays () {
      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      return new Date(year, month, 0).getDate()
    },
    // 未推送消息的获取时间戳方法
    notPushTimeRange (val) {
      let timeStamp = new Date().setHours(0, 0, 0, 0)
      let now = new Date()
      let nowTimeStamp = Date.parse(now) / 1000
      let days
      this.pushlinkParams.startPushTime = nowTimeStamp
      // 0 全部 1 今日 2 本周 3 本月
      switch (val) {
        case 0:
        default:
          this.pushlinkParams.endPushTime = nowTimeStamp + 63072000
          break
        case 1:
          this.pushlinkParams.endPushTime = timeStamp / 1000 + 86400
          break
        case 2:
          days = now.getDay() - 1
          this.pushlinkParams.endPushTime = timeStamp / 1000 - (86400 * days) + 86400 * 7
          break
        case 3:
          days = now.getDate() - 1
          this.pushlinkParams.endPushTime = timeStamp / 1000 - (86400 * days) + 86400 * this.getMonthDays()
          break
      }
    },
    // 全部消息的获取时间戳方法
    serchTimeRange (val) {
      let timeStamp = new Date().setHours(0, 0, 0, 0)
      let now = new Date()
      let days
      // 0 全部 1 今日 2 本周 3 本月
      switch (val) {
        case 0:
        default:
          this.pushlinkParams.startPushTime = timeStamp / 1000 - (86400 * 89)
          this.pushlinkParams.endPushTime = timeStamp / 1000 + 86400
          break
        case 1:
          this.pushlinkParams.startPushTime = timeStamp / 1000
          this.pushlinkParams.endPushTime = this.pushlinkParams.startPushTime + 86400
          break
        case 2:
          days = now.getDay() - 1
          this.pushlinkParams.startPushTime = timeStamp / 1000 - (86400 * days)
          this.pushlinkParams.endPushTime = this.pushlinkParams.startPushTime + 86400 * 7
          break
        case 3:
          days = now.getDate() - 1
          this.pushlinkParams.startPushTime = timeStamp / 1000 - (86400 * days)
          this.pushlinkParams.endPushTime = this.pushlinkParams.startPushTime + this.getMonthDays() * 86400
          break
      }
    },
    // 请求消息列表
    loadPushlinkList () {
      this.loading = true
      let url = '/pushlink/list.do'
      let params = this.pushlinkParams
      api.post(url, params, (data) => {
        // 通过this.pushlinkParams.page来判断当前是下拉加载还是筛选操作
        this.total = data.result.count
        let list = data.result.list.map((item) => {
          let msg = JSON.parse(item.msg)
          if (msg.content.length > 100) {
            item.isUnfold = true
          } else {
            item.isUnfold = false
          }
          return item
        })
        if (this.pushlinkParams.page === 1) {
          this.mPushlinklist = list

          this.$nextTick(() => {
            // 初始化左侧滚动加载
            this.bindScroll()
          })

        } else {
          this.mPushlinklist = this.mPushlinklist.concat(list)
        }
        this.getPushlinkNoRead()
        this.loading = false
      })
    },

    // 加载更多
    loadMore () {
      if (this.mPushlinklist.length && this.total > this.mPushlinklist.length) {
        this.showMore = true
        this.pushlinkParams.page++
        this.loadPushlinkList()
      } else {
        this.showMore = false
      }
    },

    // 绑定滚动下拉加载更多方法
    bindScroll () {
      const el = this.$refs.comLeft
      let oldSt = 0
      let timer

      if (el) {
        el.onscroll = ('scroll', (e) => {
          let st = el.scrollTop
          let oh = el.offsetHeight
          let sh = el.scrollHeight

          // 当没有更多数据时，终止滚动加载
          if (this.total === this.mPushlinklist.length || !this.mPushlinklist.length) {
            this.showMore = false
            return
          }

          // 增加300毫秒延时，防止短时间内被触发多次
          clearTimeout(timer)

          // 滚动到底部20px内且向下滚动时触发
          timer = setTimeout(() => {
            if ((st + oh) > (sh - 20) && st > oldSt) {
              this.loadMore()
            }
            oldSt = st
          }, 300)
        })
      } else {
        setTimeout(this.bindScroll, 50)
      }
    },
    // 请求是否还有未读，来确定'mUnreadCount'的状态
    getPushlinkNoRead () {
      let url = '/pushlink/unreadCount.do'
      api.post(url, {}, (data) => {
        this.mUnreadCount = data.result.count
      })
    },
    // 格式化时间
    formatTime (time) {
      let curTime = parseInt(new Date().getTime() / 1000)
      let poor = curTime - time
      let curDay = parseInt(new Date(new Date().setHours(0, 0, 0, 0)) / 1000)
      if (poor / 60 === 0) {
        return '现在'
      } else if (poor / 60 > 0 && poor / 60 < 60) {
        return parseInt(poor / 60) + '分钟前'
      } else if (poor / 3600 >= 1 && poor / 3600 < 5) {
        return parseInt(poor / 3600) + '小时前'
      } else if (poor / 3600 > 5 && curDay < time) {
        return '今日' + utils.formatDate(time, 'datetime').slice(11)
      } else {
        return utils.formatDate(time, 'datetime').slice(5)
      }
    },
    // 格式化内容
    formatContent (msg, type) {
      let msgJson = JSON.parse(msg)
      if (type === 'title') {
        return msgJson.title ? msgJson.title : '消息提醒'
      } else {
        return msgJson[type]
      }
    },
    getPreviewUrl (msg) {
      let msgJson = JSON.parse(msg)
      return 'https://view.xbongbong.com/view/url?url=' + msgJson['downLoadUrl']
    },
    getDownloadUrl (msg) {
      let msgJson = JSON.parse(msg)
      return msgJson['downLoadUrl']
    },
    hide () {
      if (this.detailShow === false && this.deleteBox === false) {
        this.$emit('closeMessge')
      }
    },
    tabClick (val) {
      this.pushlinkParams = {} // 重置参数
      this.currentView = val
      this.pushlinkParams.page = 1
      this.pushlinkParams.pageSize = 15
      if (val === 3) { // 下载消息
        this.pushlinkParams.isDownload = 1
        this.loadPushlinkList() // 发送请求搜索下载信息
      } else { // 全部消息和未读消息
        this.pushlinkParams.isRemind = val
        this.chooseFilter(0) // 切换tab默认按钮选中全部
      }
    },
    unfoldText (pushlink) {
      pushlink.isUnfold = false
      if (pushlink.isRead === 1) {
        return
      }
      pushlink.isRead = 1
      this.markedRead(pushlink.pushLinkId)
    },
    // 单条标为已读
    markedRead (id) {
      let url = '/pushlink/read.do'
      let params = {
        idList: [id]
      }
      api.post(url, params, (data) => {
        this.updateRemindCount('reduce')
        this.mPushlinklist.map((item) => {
          if (item.pushLinkId === id) {
            item.isRead = 1
          }
        })
      })
    },
    // 一键标为已读
    markedAsRead () {
      if (this.mUnreadCount === 0) {
        return
      }
      let url = '/pushlink/readAll.do'
      api.post(url, {}, (data) => {
        this.updateRemindCount(0)
        this.mUnreadCount = 0
        this.mPushlinklist.map((item) => {
          item.isRead = 1
        })
      })
    },
    // 合同，客户，机会，联系人有详情抽屉的弹出抽屉，没有跳到列表页
    // 审批需在本地存储审批类型，销售简报需要参数
    showDetail (pushlink) {
      // pushlink.isPush = 0 为即将提醒，暂不做处理（金小瑞)
      if (!pushlink.refEntity) {
        return
      }
      if (pushlink.isPush === 0) {
        Message('此消息暂未推送,不支持详情查看')
        return
      }
      this.detailId = pushlink.refId
      if (pushlink.isRead === 0) {
        this.markedRead(pushlink.pushLinkId)
      }
      let title = JSON.parse(pushlink.msg).title
      if (JSON.parse(pushlink.refArray).length > 1) {
        this.$router.push({path: '/message/statistical?pushId=' + pushlink.id + '&pushType=' + pushlink.type + '&title=' + title})
      } else {
        switch (pushlink.type) {
          case 6: // 合同
            this.popModel = 'contractApi'
            this.detailShow = true
            break
          case 3: // 客户
            this.popModel = 'customerApi'
            this.detailShow = true
            break
          case 14: // 联系人
            this.popModel = 'contactApi'
            this.detailShow = true
            break
          case 7: // 审批
            LS.set(`VUE-message-approval`, pushlink.belongerType)
            this.$router.push({path: '/approval'})
            break
          case 10: // 回款
            if (pushlink.subType === 0 || pushlink.subType === 5) { // 回款逾期和未回款跳到回款列表
              this.$router.push({path: '/payment'})
            } else {
              this.popModel = 'paymentApi'
              this.detailShow = true
            }
            break
          case 4: // 销售机会
            this.popModel = 'opportunityApi'
            this.detailShow = true
            break
          case 22: // 工单
            this.$router.push({path: '/workOrder'})
            break
          case 5: // 跟进记录
            this.$router.push({path: '/communicate'})
            break
          case 2: // 访客计划
            this.$router.push({path: '/communicatePlan'})
            break
          case 12: // 工作报告
            this.$router.push({path: '/workReport'})
            break
          case 16: // 发票
            this.popModel = 'invoice'
            this.detailShow = true
            break
          case 33: // 签到
            this.popModel = 'customerApi'
            this.detailShow = true
            break
          case 1: // 销售简报
            this.$router.push({path: '/salesReport?start=' + pushlink.start + '&end=' + pushlink.end})
            break
          case 90: // 采购合同
            if (!pushlink.subType) { // 采购合同详情
              this.popModel = 'purchase'
              this.detailShow = true
            } else { // 待采购列表
              this.$router.push({path: '/wForPurchase'})
            }
            break
          case 103: // 入库
            if (!pushlink.subType) { // 入库单详情
              this.popModel = 'instock'
              this.detailShow = true
            } else { // 待入库列表
              this.$router.push({path: '/waitInstock'})
            }
            break
          case 104: // 出库
            if (!pushlink.subType) { // 出库单详情
              this.popModel = 'outstock'
              this.detailShow = true
            } else { // 待出库列表
              this.$router.push({path: '/waitOutstock'})
            }
            break
          case 107: // 供应商
            this.popModel = 'supplier'
            this.detailShow = true
            break
          case 117: // BOM清单
            this.popModel = 'bomBill'
            this.detailShow = true
            break
          case 118: // 生产单
            this.popModel = 'productionOrder'
            this.detailShow = true
            break
          case 100: // 采购退货单
            this.popModel = 'returnedPurchase'
            this.detailShow = true
            break
          case 0: // 系统通知
            this.popModel = 'returnedPurchase'
            this.detailShow = true
            break
          default:
            return
        }
        this.hide()
      }
    },
    // 关闭详情
    closeDetail () {
      this.detailShow = false
    },
    // 是否弹出删除消息弹框
    // confirmDelete (curMessage) {
    //   this.curMessage = curMessage
    //   if (!LS.get(`VUE-message-delete`)) {
    //     this.$emit('openDeleteBox')
    //   } else {
    //     this.submitDelete()
    //   }
    // },
    // // 删除消息
    // submitDelete (checked) {
    //   if (checked) {
    //     LS.set(`VUE-message-delete`, checked)
    //   }
    //   let url = `/pushlink/delete.do`
    //   let params = {
    //     idList: [this.curMessage.pushLinkId]
    //   }
    //   api.post(url, params, (data) => {
    //     for (let i = 0; i < this.mPushlinklist.length; i++) {
    //       if (this.mPushlinklist[i].pushLinkId === this.curMessage.pushLinkId) {
    //         this.mPushlinklist.splice(i, 1)
    //         this.total--
    //         return
    //       }
    //     }
    //   })
    // },
    colorIcon (pushlink) {
      if (pushlink.isRemind) {
        return 'remind'
      } else {
        switch (pushlink.refEntity) {
          case 0: // 系统消息推送
            return 'remind'
          case 17: // 销售简报
            return 'remind'
          case 8: // 访客计划
            return 'icon-communicatePlan'
          case 2: // 客户
          case 18: // 公海客户
            return 'icon-customer'
          case 5: // 销售机会
            return 'icon-opportunity'
          case 6: // 跟进记录
            return 'icon-communicate'
          case 1: // 合同
            return 'icon-contract'
          case 4: // 审批
            return 'icon-approval'
          case 10: // 未回款
          case 11: // 回款
          case 13: // 回款计划
            return 'icon-payment'
          case 12: // 工作报告
            return 'icon-workReport'
          case 3: // 联系人推送
            return 'icon-contact'
          case 16: // 发票推送
            return 'icon-invoice'
          case 19: // 退货退款
            return 'icon-refund'
          case 22: // 工单
            return 'icon-workOrder'
          case 25: // SFA
            return 'icon-strategy'
          case 31: // 导出成功
            return 'el-icon-download green'
          case 32: // 导出失败
            return 'el-icon-download red'
          case 90: // 采购合同推送
            return 'icon-purchase'
          case 103: // 入库推送
            return 'icon-instock'
          case 104: // 出库推送
            return 'icon-supplier'
          case 107: // 供应商推送
            return 'icon-outstock'
          case 117: // BOM清单
            return 'icon-contract'
          case 118: // 生产单
            return 'icon-contract'
          case 100: // 采购退货单
            return ''
          default:
            return 'remind'
        }
      }
    }
  },
  watch: {
    mPushlinklist: {
      handler () {
        if (this.mPushlinklist.length < this.pushlinkParams.pageSize) {
          this.loadMore()
        }
      },
      deep: true
    }
  },
  directives: { Clickoutside }
}
</script>

</style>
<style lang="less" scoped>
.messageList {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 2000;
  font-size: 13px;
  color: rgba(146,146,146,1);
  button {
    font-size: 13px;
  }
	.message {
    position: absolute;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
		width: 400px;
		background: #fff;
		top: 40px;
		right: 0;
		bottom: 0;
    border-left: 1px solid rgba(255, 255, 255, 1);
    box-shadow: -4px 0 12px 0px rgba(0, 0, 0, 0.15);
    .icon-contract,.icon-opportunity,.icon-workReport,.icon-approval,.icon-communicatePlan {
      color: #53B656;
    }
    .icon-customer {
      color: #458CFD;
    }
    .icon-contact,.icon-communicate {
      color: #FF943E
    }
    .title {
      display: flex;
      flex:0 0 auto;
      align-items: center;
      justify-content: space-between;
      height: 52px;
      line-height: 52px;
      background: #ffffff;
      padding: 0 20px;
      box-sizing:border-box;
      -moz-box-sizing:border-box; /* Firefox */
      -webkit-box-sizing:border-box; /* Safari */
      border-bottom: 1px solid rgba(0,0,0,0.05);
      .tabs {
        .tab {
          margin-right: 20px;
          cursor: pointer;
          color: rgba(102,102,102,1);
        }
        .active {
          position: relative;
          color: rgba(255,148,62,1);
          &:after {
            content: '';
            position: absolute;
            display: inline-block;
            height: 2px;
            width: 116%;
            background: #ff943e;
            bottom: -18px;
            left: -4px;
          }
        }
      }
    }
    .readBtn {
      font-size: 12px;
    }
    .mRead {
      color: rgba(146,146,146,1);
      cursor: not-allowed;
    }
    .filter {
      padding: 0 18px;
      background:#f5f9ff;
      border-bottom:1px solid #dedfed;
      -moz-user-select:none;
      .filter-tag-title {
        padding: 12px 0 0 12px;
        font-size:10px;
        color:#666666;
      }
      .filter-title {
        margin-top: 15px;
        .open-filter-icon {
          margin-left: 55px;
          cursor: pointer;
        }
      }
      .tag {
        cursor: pointer;
        display: inline-block;
        padding: 0 8px;
        background:rgba(172,172,172,0.60);
        border:1px solid #cdcdcd;
        border-radius:66px;
        line-height:18px;
        font-size:10px;
        color:#ffffff;
        letter-spacing:0;
        text-align:center;
        margin:0 0 10px 12px;
      }
      .tag-all {
        color: #6A82A4;
        border:1px solid #6A82A4;
        background:rgba(149,168,194,0.40);
      }
      .tag-customer,.tag-sales-automation {
        color: #458CFD;
        border:1px solid #458cfd;
        background:rgba(69, 140, 253, 0.25);
      }
      .tag-sale,.tag-sales-presentations {
        color: #FF943E;
        border:1px solid #FF943E;
        background:rgba(255, 148, 61, 0.25);
      }
      .tag-contract,.tag-visitor-plan,.tag-approve {
        color: #53B656;
        border:1px solid #53B656;
        background:rgba(83, 182, 86, 0.2);
      }
      .tag-follow-up {
        color: #9A89B9;
        border:1px solid #9A89B9;
        background:rgba(154, 137, 185, 0.25);
      }
      .tag-work-statement,.tag-contacts,.tag-work-order{
        color: #5EC9F6;
        border:1px solid #5EC9F6;
        background:rgba(94, 200, 246, 0.25);
      }
      .time-tag {
        color:#6A82A4;
        background:rgba(149,168,194,0.40);
        border:1px solid #6A82A4;
      }
    }
    .content {
      background:#f5f9ff;
      flex-grow: 1;
      height: 80%;
      overflow: auto;
      &::-webkit-scrollbar {display:none}
      &.emptyStyle {
        position: initial;
      }
      .empty {
        position: absolute;
        top: 45%;
        left: 25%;
        bottom: 0;
        text-align: center;
        .text {
          font-size: 15px;
          color: rgba(102,102,102,1);
          margin-top: 20px;
        }
      }
      .messages {
        display: flex;
        flex-direction:column;
        align-items:center;
        .item {
          display: flex;
          padding: 20px 15px;
          box-sizing: border-box;
          width: 380px;
          margin-top: 12px;
          background:#ffffff;
          box-shadow:0 2px 4px 0 #d8dfeb;
          border-radius:4px;
          .remind:before {
            content: '';
            display: inline-block;
            width:  10px;
            height: 10px;
            background: rgba(255,148,62,1);
            border-radius: 100%;
            margin: 6px;
          }
          .iconPre {
            font-size: 22px;
            margin-right: 12px;
            &.green {
              color: #53B656;
            }
            &.red {
              color: #ff6161;
            }
          }
          .el-icon-circle-close {
            display: flex;
            align-items: center;
            cursor: pointer;
          }
          .el-icon-circle-close:hover {
            color: #ff6161;
          }
          .middle {
            position: relative;
            width: 290px;
            margin-right: 20px;
            .unfoldBtn {
              position: absolute;
              right: 0;
              bottom: -7px;
              background: #fff;
              padding-left: 3px;
            }
            .frist {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 8px;
              .name {
                position: relative;
                font-size: 16px;
                color: #222222;
                line-height: 18px;
                cursor: pointer;
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding-right: 46px;
              }
              .time {
                flex: 0 0 auto;
              }
              .noRead::after {
                content: '';
                position: absolute;
                margin-left: 5px;
                display: inline-block;
                width:6px;
                height:6px;
                background:rgba(255,97,97,1);
                border-radius: 100%;
              }
            }
            .bottom {
              .text {
                line-height:20px;
                overflow : hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .download-content {
                display: inline-block;
                width:200px;
              }
              .link {
                margin-left: 10px;
              }
              .unfold {
                -webkit-line-clamp: inherit;
                overflow : visible;
              }
            }
          }
        }
      }
    }
	}
}
</style>



// WEBPACK FOOTER //
// message-list.vue?363a52ca